import React, { createContext, useContext, useMemo } from 'react';
import UnilateralStrategy from './unilateral';
import EmptyStrategy from './empty';
import { useModalWatch } from '../../../shared/packages/modalManager';
import { modalNames } from '../../../shared/configs/modal';
import { roomAttachmentModalActions } from '../../../shared/configs/attachments';
import AddAttachmentStrategy from './addAttachment';
import EditAttachmentStrategy from './editAttachment';

const strategies = {
  [roomAttachmentModalActions.setUnilateral]: UnilateralStrategy,
  [roomAttachmentModalActions.addAttachment]: AddAttachmentStrategy,
  [roomAttachmentModalActions.editAttachment]: EditAttachmentStrategy,
};

const Context = createContext();

export const useStrategyContexts = () => useContext(Context);

export const StrategyProvider = ({ children }) => {
  const actionType = useModalWatch({
    name: modalNames.attachmentsForm,
    selector: (state) => state?.props?.actionType,
  });

  const { Provider, contexts } = useMemo(() => {
    const { Provider, ...contexts } = strategies[actionType] ?? EmptyStrategy;
    return { Provider, contexts };
  }, [actionType]);

  return (
    <Provider>
      <Context.Provider value={contexts}>{children}</Context.Provider>
    </Provider>
  );
};
